import { Moment } from 'moment';
import { DateUtils } from '../../../common/utils/DateUtils';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { Scan } from '../models/Scan';
import { Project } from '../models/valueObjects/Project';

export class ScanMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): Scan {
    let endedAt: Moment | null = null;
    if (data.endedAt) {
      endedAt = DateUtils.toMoment(data.endedAt);
    }
    let project: Project | null = null;
    if (data.project) {
      project = new Project(this.gqlIdEncoder.decode(data.project.id), data.project.name);
    }
    return new Scan(
      this.gqlIdEncoder.decode(data.id),
      data.name,
      data.status,
      endedAt,
      project,
      DateUtils.toMoment(data.startedAt),
      data.totalHosts,
      data.failedHosts,
      data.successfulHosts
    );
  }
}
